import React from 'react';
import PropTypes from 'prop-types';
import { ContinuousLinearTracker } from '@americanexpress/dls-react';

const ContinuousLinearTrackerProgress = (props) => {
  const {
    cssProperties,
    max,
    min,
    variant = 'default',
    formSubmissionPayload,
    completionText,
    color = 'success',
    weight = 'thin',
    progressCurrentValue,
    stepLabel = 'Step',
    showProgressLabel = false,
    progressBarHeight,
    hasGradient = false,
  } = props;

  const maxStep = formSubmissionPayload.maxContinuousLinearTrackerStep || max;
  const minStep = formSubmissionPayload.minContinuousLinearTrackerStep || min;
  // eslint-disable-next-line max-len -- DLS payload key names produce a line that exceeds 100 chars
  const currentStep = formSubmissionPayload.currentContinuousLinearTrackerStep || progressCurrentValue;

  return (
    <div className={cssProperties?.style}>
      <ContinuousLinearTracker
        completionText={completionText || ''}
        hasGradient={hasGradient}
        labelOverrides={{
          getScreenReaderLabel: function Xs() { },
          getScreenReaderValueText: function Xs() { },
          getTrackerEndText: (r, e, a) => `${e} of ${a} - Pages`,
          getTrackerStartText: (r) => `${r} Page`,
        }}
        max={maxStep}
        min={minStep}
        value={currentStep}
        variant={variant}
        color={color}
        weight={weight}
        theme={progressBarHeight ? { height: progressBarHeight } : {}}
      />
      {showProgressLabel && (
        <p className="legal-2 flex flex-justify-between pad-1-t">
          <span />
          <span>
            <span aria-live="polite">
              {stepLabel}{' '}{progressCurrentValue}
              <span className="sr-only">
                {' '}pages completed
              </span>
            </span>
            {' '}of {max}{' '}
          </span>
        </p>
      )}

    </div>
  );
};

ContinuousLinearTrackerProgress.propTypes = {
  cssProperties: PropTypes.objectOf(PropTypes.string),
  hasGradient: PropTypes.bool,
  max: PropTypes.number,
  min: PropTypes.number,
  variant: PropTypes.string,
  completionText: PropTypes.string,
  color: PropTypes.string,
  weight: PropTypes.string,
  progressCurrentValue: PropTypes.number,
  formSubmissionPayload: PropTypes.objectOf(PropTypes.shape),
  showProgressLabel: PropTypes.bool,
  stepLabel: PropTypes.string,
  progressBarHeight: PropTypes.string,
};

export default ContinuousLinearTrackerProgress;
